import { ExternalLink } from "lucide-react";

interface TikTokEmbedProps {
  handle: string;
}

export function TikTokEmbed({ handle }: TikTokEmbedProps) {
  const cleanHandle = handle.replace(/^@/, "");
  const embedSrc = `https://www.tiktok.com/embed/@${encodeURIComponent(cleanHandle)}`;
  const profileUrl = `https://www.tiktok.com/@${encodeURIComponent(cleanHandle)}`;

  return (
    <div className="tw-flex tw-flex-col tw-gap-1.5">
      <div className="tw-flex tw-items-center tw-justify-between tw-text-[11px] tw-text-muted-foreground">
        <span className="tw-font-semibold tw-uppercase tw-tracking-wider">
          TikTok preview
        </span>
        <a
          href={profileUrl}
          target="_blank"
          rel="noreferrer"
          className="tw-inline-flex tw-items-center tw-gap-1 hover:tw-text-foreground"
        >
          Open <ExternalLink className="tw-h-2.5 tw-w-2.5" />
        </a>
      </div>
      <div className="tw-overflow-hidden tw-rounded-md tw-border tw-border-border tw-bg-muted">
        <iframe
          title={`TikTok @${cleanHandle}`}
          src={embedSrc}
          className="tw-h-[420px] tw-w-full tw-border-0"
          allow="encrypted-media"
          referrerPolicy="strict-origin-when-cross-origin"
          sandbox="allow-scripts allow-same-origin allow-popups"
        />
      </div>
    </div>
  );
}
